import ClassHelper from '../ClassHelper';

class CashierRewards extends ClassHelper {
  constructor({ date, amount } = {}) {
    super(...arguments);
    this.amount = amount;
    this.date = date;
  }
}

export default CashierRewards;